import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {UserGroupTypeBO} from "./UserGroupTypeBO";
import * as _ from "lodash";


export class UserGroupTypeBOValidations {

    static Validate(aBO: UserGroupTypeBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            UserGroupTypeBOValidations.ValidateHeaderFields(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static async ValidateHeaderFields(aBO: UserGroupTypeBO): Promise<void> {

        const self = this;
        let name = aBO.WB_UserGroupType.cif.USRGRPM_NAME

        if(name == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingName',
                    type: MessageType.Error,
                    title: "Name cannot be empty",
                    description:"Name cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingName')
        }

        let id = aBO.WB_UserGroupType.cif.USRGRPM_ID

        if(id == '') {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingID',
                    type: MessageType.Error,
                    title: "ID cannot be empty",
                    description:"ID cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingID')
        }

        let mdSet = aBO.WB_UserGroupType.cif.WB_MDSET_ID

        if(mdSet <= 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingMDSet',
                    type: MessageType.Error,
                    title: "Master Data Set cannot be empty",
                    description:"Master Data Set cannot be empty.",
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('MissingMDSet')
        }
    }

    static async ValidateDelete(aBO: UserGroupTypeBO): Promise<void> {
        aBO.DeleteMessageProvider.clearMessages()

        let activeUserGroups = _.filter(aBO.WB_UserGroupType.WB_UserGroupRows, aRow => aRow.isActive)

         if(activeUserGroups.length > 0) {
             aBO.DeleteMessageProvider.addMessage({
                 code: 'UserGroupExist',
                 type: MessageType.Error,
                 title: "User Group Type cannot be deleted because there are user groups existing associated to this",
                 description: "User Group Type cannot be deleted because there are user groups existing associated to this"
             })
         }
    }
}